import VueRouter from 'vue-router'
//引入组件
import Index from '../pages'
import Home from '../pages/home/home'
import Login from '../pages/login/login'
import Register from '../pages/register/register'
import Center from '../pages/center/center'
import Storeup from '../pages/storeup/list'
import payList from '../pages/pay'

import yonghuList from '../pages/yonghu/list'
import yonghuDetail from '../pages/yonghu/detail'
import yonghuAdd from '../pages/yonghu/add'
import chongwuxinxiList from '../pages/chongwuxinxi/list'
import chongwuxinxiDetail from '../pages/chongwuxinxi/detail'
import chongwuxinxiAdd from '../pages/chongwuxinxi/add'
import chongwuzhongleiList from '../pages/chongwuzhonglei/list'
import chongwuzhongleiDetail from '../pages/chongwuzhonglei/detail'
import chongwuzhongleiAdd from '../pages/chongwuzhonglei/add'
import gongzuorenyuanList from '../pages/gongzuorenyuan/list'
import gongzuorenyuanDetail from '../pages/gongzuorenyuan/detail'
import gongzuorenyuanAdd from '../pages/gongzuorenyuan/add'
import jiyangdianList from '../pages/jiyangdian/list'
import jiyangdianDetail from '../pages/jiyangdian/detail'
import jiyangdianAdd from '../pages/jiyangdian/add'
import fuwuleixingList from '../pages/fuwuleixing/list'
import fuwuleixingDetail from '../pages/fuwuleixing/detail'
import fuwuleixingAdd from '../pages/fuwuleixing/add'
import jiyangfuwuList from '../pages/jiyangfuwu/list'
import jiyangfuwuDetail from '../pages/jiyangfuwu/detail'
import jiyangfuwuAdd from '../pages/jiyangfuwu/add'
import jiyangxinxiList from '../pages/jiyangxinxi/list'
import jiyangxinxiDetail from '../pages/jiyangxinxi/detail'
import jiyangxinxiAdd from '../pages/jiyangxinxi/add'
import chongwuyanghuList from '../pages/chongwuyanghu/list'
import chongwuyanghuDetail from '../pages/chongwuyanghu/detail'
import chongwuyanghuAdd from '../pages/chongwuyanghu/add'
import chongwuwendaList from '../pages/chongwuwenda/list'
import chongwuwendaDetail from '../pages/chongwuwenda/detail'
import chongwuwendaAdd from '../pages/chongwuwenda/add'
import huidaxinxiList from '../pages/huidaxinxi/list'
import huidaxinxiDetail from '../pages/huidaxinxi/detail'
import huidaxinxiAdd from '../pages/huidaxinxi/add'
import jifenshangpinList from '../pages/jifenshangpin/list'
import jifenshangpinDetail from '../pages/jifenshangpin/detail'
import jifenshangpinAdd from '../pages/jifenshangpin/add'
import jifenduihuanList from '../pages/jifenduihuan/list'
import jifenduihuanDetail from '../pages/jifenduihuan/detail'
import jifenduihuanAdd from '../pages/jifenduihuan/add'
import lingquxinxiList from '../pages/lingquxinxi/list'
import lingquxinxiDetail from '../pages/lingquxinxi/detail'
import lingquxinxiAdd from '../pages/lingquxinxi/add'
import chatmessageList from '../pages/chatmessage/list'
import chatmessageDetail from '../pages/chatmessage/detail'
import chatmessageAdd from '../pages/chatmessage/add'
import friendList from '../pages/friend/list'
import friendDetail from '../pages/friend/detail'
import friendAdd from '../pages/friend/add'
import discussjiyangdianList from '../pages/discussjiyangdian/list'
import discussjiyangdianDetail from '../pages/discussjiyangdian/detail'
import discussjiyangdianAdd from '../pages/discussjiyangdian/add'
import discussjiyangfuwuList from '../pages/discussjiyangfuwu/list'
import discussjiyangfuwuDetail from '../pages/discussjiyangfuwu/detail'
import discussjiyangfuwuAdd from '../pages/discussjiyangfuwu/add'
import discusschongwuyanghuList from '../pages/discusschongwuyanghu/list'
import discusschongwuyanghuDetail from '../pages/discusschongwuyanghu/detail'
import discusschongwuyanghuAdd from '../pages/discusschongwuyanghu/add'
import discussjifenshangpinList from '../pages/discussjifenshangpin/list'
import discussjifenshangpinDetail from '../pages/discussjifenshangpin/detail'
import discussjifenshangpinAdd from '../pages/discussjifenshangpin/add'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

//配置路由
export default new VueRouter({
	routes:[
		{
      path: '/',
      redirect: '/index/home'
    },
		{
			path: '/index',
			component: Index,
			children:[
				{
					path: 'home',
					component: Home
				},
				{
					path: 'center',
					component: Center,
				},
				{
					path: 'pay',
					component: payList,
				},
				{
					path: 'storeup',
					component: Storeup
				},
				{
					path: 'yonghu',
					component: yonghuList
				},
				{
					path: 'yonghuDetail',
					component: yonghuDetail
				},
				{
					path: 'yonghuAdd',
					component: yonghuAdd
				},
				{
					path: 'chongwuxinxi',
					component: chongwuxinxiList
				},
				{
					path: 'chongwuxinxiDetail',
					component: chongwuxinxiDetail
				},
				{
					path: 'chongwuxinxiAdd',
					component: chongwuxinxiAdd
				},
				{
					path: 'chongwuzhonglei',
					component: chongwuzhongleiList
				},
				{
					path: 'chongwuzhongleiDetail',
					component: chongwuzhongleiDetail
				},
				{
					path: 'chongwuzhongleiAdd',
					component: chongwuzhongleiAdd
				},
				{
					path: 'gongzuorenyuan',
					component: gongzuorenyuanList
				},
				{
					path: 'gongzuorenyuanDetail',
					component: gongzuorenyuanDetail
				},
				{
					path: 'gongzuorenyuanAdd',
					component: gongzuorenyuanAdd
				},
				{
					path: 'jiyangdian',
					component: jiyangdianList
				},
				{
					path: 'jiyangdianDetail',
					component: jiyangdianDetail
				},
				{
					path: 'jiyangdianAdd',
					component: jiyangdianAdd
				},
				{
					path: 'fuwuleixing',
					component: fuwuleixingList
				},
				{
					path: 'fuwuleixingDetail',
					component: fuwuleixingDetail
				},
				{
					path: 'fuwuleixingAdd',
					component: fuwuleixingAdd
				},
				{
					path: 'jiyangfuwu',
					component: jiyangfuwuList
				},
				{
					path: 'jiyangfuwuDetail',
					component: jiyangfuwuDetail
				},
				{
					path: 'jiyangfuwuAdd',
					component: jiyangfuwuAdd
				},
				{
					path: 'jiyangxinxi',
					component: jiyangxinxiList
				},
				{
					path: 'jiyangxinxiDetail',
					component: jiyangxinxiDetail
				},
				{
					path: 'jiyangxinxiAdd',
					component: jiyangxinxiAdd
				},
				{
					path: 'chongwuyanghu',
					component: chongwuyanghuList
				},
				{
					path: 'chongwuyanghuDetail',
					component: chongwuyanghuDetail
				},
				{
					path: 'chongwuyanghuAdd',
					component: chongwuyanghuAdd
				},
				{
					path: 'chongwuwenda',
					component: chongwuwendaList
				},
				{
					path: 'chongwuwendaDetail',
					component: chongwuwendaDetail
				},
				{
					path: 'chongwuwendaAdd',
					component: chongwuwendaAdd
				},
				{
					path: 'huidaxinxi',
					component: huidaxinxiList
				},
				{
					path: 'huidaxinxiDetail',
					component: huidaxinxiDetail
				},
				{
					path: 'huidaxinxiAdd',
					component: huidaxinxiAdd
				},
				{
					path: 'jifenshangpin',
					component: jifenshangpinList
				},
				{
					path: 'jifenshangpinDetail',
					component: jifenshangpinDetail
				},
				{
					path: 'jifenshangpinAdd',
					component: jifenshangpinAdd
				},
				{
					path: 'jifenduihuan',
					component: jifenduihuanList
				},
				{
					path: 'jifenduihuanDetail',
					component: jifenduihuanDetail
				},
				{
					path: 'jifenduihuanAdd',
					component: jifenduihuanAdd
				},
				{
					path: 'lingquxinxi',
					component: lingquxinxiList
				},
				{
					path: 'lingquxinxiDetail',
					component: lingquxinxiDetail
				},
				{
					path: 'lingquxinxiAdd',
					component: lingquxinxiAdd
				},
				{
					path: 'chatmessage',
					component: chatmessageList
				},
				{
					path: 'chatmessageDetail',
					component: chatmessageDetail
				},
				{
					path: 'chatmessageAdd',
					component: chatmessageAdd
				},
				{
					path: 'friend',
					component: friendList
				},
				{
					path: 'friendDetail',
					component: friendDetail
				},
				{
					path: 'friendAdd',
					component: friendAdd
				},
				{
					path: 'discussjiyangdian',
					component: discussjiyangdianList
				},
				{
					path: 'discussjiyangdianDetail',
					component: discussjiyangdianDetail
				},
				{
					path: 'discussjiyangdianAdd',
					component: discussjiyangdianAdd
				},
				{
					path: 'discussjiyangfuwu',
					component: discussjiyangfuwuList
				},
				{
					path: 'discussjiyangfuwuDetail',
					component: discussjiyangfuwuDetail
				},
				{
					path: 'discussjiyangfuwuAdd',
					component: discussjiyangfuwuAdd
				},
				{
					path: 'discusschongwuyanghu',
					component: discusschongwuyanghuList
				},
				{
					path: 'discusschongwuyanghuDetail',
					component: discusschongwuyanghuDetail
				},
				{
					path: 'discusschongwuyanghuAdd',
					component: discusschongwuyanghuAdd
				},
				{
					path: 'discussjifenshangpin',
					component: discussjifenshangpinList
				},
				{
					path: 'discussjifenshangpinDetail',
					component: discussjifenshangpinDetail
				},
				{
					path: 'discussjifenshangpinAdd',
					component: discussjifenshangpinAdd
				},
			]
		},
		{
			path: '/login',
			component: Login
		},
		{
			path: '/register',
			component: Register
		},
	]
})
